(function() {
    angular
        .module('emarket.main.profile')
        .controller('ChangePasswordDialogController', ['$log', '$mdDialog', '$mdToast', 'Profile', function($log, $mdDialog, $mdToast, Profile) {
            var vm = this;
            vm.close = function() {
                $mdDialog.hide();
            };
            vm.changePassword = function() {
                $log.info('changing password');
                Profile.changePassword(vm.current, vm.password).then(function(response) {
                    var toast = $mdToast.simple().textContent(response.message);
                    $mdToast.show(toast);
                    vm.close();
                });
            };
        }]);
}());
